<script lang="ts">
	//UI
	import { AdaptiveTextInput, SearchIcon_2 } from "@hitit/new_ui/src";

	//Utils
	//Types
	//Props
	export let value = "";
	export let noFocusoutline = true;
	export let inputBackgroundColor = "";
	export let placeholder = "";
	//Constants
	//Variables
	//Functions
	//Do

</script>

<div class="container">
	<AdaptiveTextInput
		on:input
		bind:value
		noFocusoutline={noFocusoutline}
		backgroundColor={inputBackgroundColor}
		placeholder={placeholder}>
		<div class="search-icon" slot="left-icon">
			<SearchIcon_2 />
		</div>
	</AdaptiveTextInput>
</div>

<style lang="scss">
	@import "../variables.scss";

	.container {
		width: 100%;
		height: 31px;
		color: #46474b;
		position: relative;

		.search-icon {
			width: 15.8px;
			height: 15.8px;
			margin-right: 10px;
		}
	}
	@include DesktopSize {
		.container {
			height: 40px;
			font-size: 1.25rem;
			.search-icon {
				width: 23.5px;
				height: 25.5px;
			}
		}
	}

</style>
